<template>
  <div class="navbar">
    <div class="top">
      <div class="logo">萨岗陀骆</div>
      <div class="menu">
        <router-link to="/index" class="item">首页</router-link>
        <router-link to="/aboutus" class="item">关于我们</router-link>
        <router-link to="/join" class="item">加盟我们</router-link>
        <router-link to="/contact" class="item">联系我们</router-link>
      </div>
      <div class="login" @click="navTo('login')" v-if="user.name == '' ">登录</div>
      <div class="login" @click="navTo('login')" v-else>
        <el-dropdown>
          <span class="el-dropdown-link">
            {{ user.name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><router-link to="/person/index" class="item">个人资料</router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/person/changepwd" class="item">修改密码</router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/person/buyvip" class="item">购买会员</router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/person/order" class="item">我的订单</router-link></el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo, logout } from '@/api/user'
import { Message } from 'element-ui';
import { mapState, mapGetters } from 'vuex';
  export default {
    name: 'Navbar',
    data() {
      return {
        current: 'home',
        userInfo: {},
        isLogin: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    created() {
      this.getUserInfo()
    },
    methods: {
      navTo(path) {
        this.$emit('nav-click', path)
      },
      getUserInfo() {
        this.$store.dispatch('user/getInfo').then(res => {
          this.isLogin = true
          this.userInfo = res.data
        }).catch(error => {
          this.isLogin = false
          return
        })
      },
      async logout() {
        // await this.$store.dispatch('user/logout')
        try {
          await this.$store.dispatch('user/logout')
          this.$router.push({ path: '/login' })
        } catch(error) {
          console.error('Logout failed:', error)
          Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.navbar {
  background: #0056A3;
  height:60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .top {
    width: 1200px;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .logo {
      display: flex;
      align-items: center;
      font-size: 35px;
      font-weight: bold;
    }

    .menu {
      font-size: 24px;
      display: flex;
      align-items: center;
      height: 60px;
      .item {
        width: 150px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .router-link-active {
        background: #ffffff;
        color: #0056A3;
      }
    }
    .login {
      font-size: 24px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .el-dropdown-link {
      color: #ffffff;
      font-size: 20px;
    }
  }
}
</style>